import React from "react"
import { Box, Text, Flex, Link } from "theme-ui"
import { i18nContext } from "../context/i18nContext"
import { InboundLink } from "./link"
import { getPagePath, getArticlePath } from "../utils/path"

const ArticleBanner = ({ title, subtitle, documents, link, locale }) => {
  const isExternal = link?.model?.apiKey === "external_link"
  const isInternal = link?.model?.apiKey === "internal_link"

  const getInternalPath = () => {
    if (!link?.link) return null
    const linkedItem = link.link
    if (linkedItem.root !== undefined) {
      return getPagePath(linkedItem, locale)
    }
    if (linkedItem.slug !== undefined) {
      return getArticlePath(linkedItem, locale)
    }
    return null
  }

  const buttonStyles = {
    backgroundColor: "light",
    color: "primary",
    padding: "10px 20px",
    borderRadius: "40px",
    textTransform: "uppercase",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "1.2",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    border: "1px solid",
    borderColor: "transparent",
    ":hover": {
      backgroundColor: "primary",
      color: "light",
      transition: "all 0.3s ease-in-out",
      cursor: "pointer",
      borderColor: "light",
    },
  }

  return (
    <i18nContext.Consumer>
      {t => (
        <Box
          sx={{
            backgroundColor: "primary",
            py: ["20px", "20px", "40px"],
            px: ["40px", "40px", "60px"],
            borderRadius: "40px",
          }}
        >
          <Flex sx={{ flexDirection: "column", gap: "20px" }}>
            <Text
              sx={{
                fontSize: "34px",
                fontWeight: 400,
                color: "light",
                lineHeight: "1.2",
              }}
            >
              {title}
            </Text>
            <Text sx={{ color: "light", fontSize: "21px" }}>{subtitle}</Text>
          </Flex>
          <Flex sx={{ mt: "20px", gap: "10px", flexWrap: "wrap" }}>
            {documents?.map(document => (
              <Link
                key={document.url}
                sx={buttonStyles}
                target="_blank"
                href={document.url}
                alt={document.title}
              >
                <Text>{t.guide}</Text>
              </Link>
            ))}
            {isExternal && link.url && (
              <Link
                sx={buttonStyles}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Text>{link.anchor}</Text>
              </Link>
            )}
            {isInternal && getInternalPath() && (
              <InboundLink to={getInternalPath()} sx={buttonStyles}>
                <Text>{link.anchor}</Text>
              </InboundLink>
            )}
          </Flex>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}

export default ArticleBanner
